module.exports = __webpack_public_path__ + "static/img/bgimg4.0e54568f.png";